module.exports = __webpack_public_path__ + "img/copy-icon.5ccfb965.svg";